/**
 * Model to hold login data.
 */
export class Credentials {
  public username = '';

  public password = '';
}
